<template>
  <div id="app">
    <page-frame></page-frame>
  </div>
</template>

<script>
import PageFrame from ".././src/components/Frame/PageFrame.vue";

export default {
  name: 'App',
  components: {
    PageFrame,
  }
}
</script>

<style>
* {
  margin: 0;
  padding: 0;
}
</style>
